<template>
    <div class="row" v-show="!isLessonHistory">
        <div class="col-12">
            <div class="card py-2">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body text-elev-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" viewBox="0 0 20 20"
                                 fill="currentColor">
                                <path
                                    d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <h5 class="card-title text-2xl mb-0">
                                <strong>
                                    {{ $t('Opplæring i klasse {className}', {className: classShortName}) }}
                                </strong>
                            </h5>
                            <ClassSelect :inline="true"></ClassSelect>
                        </div>
                    </div>
                    <div class="col-12 col-md-10 offset-md-2">
                        <div class="hr-wrapper my-3">
                            <hr>
                        </div>
                        <div class="card-body pt-1">
                            <div v-for="module in modules">
                                <h4 v-html="module.title"></h4>
                                <div class="row">
                                    <ul class="square-list">
                                        <StandardListElement
                                            v-for="element in module.elements.filter(el => el.visible_in_ec)"
                                            :key="element.element_id"
                                            :element="element"></StandardListElement>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/teachingCardStore';
import Nl2br from 'vue3-nl2br';
import ClassSelect from "../classSelect/ClassSelect";
import StandardListElement from "./StandardListElement";

const classShortName = computed(() => Store.getClassShortName());
const elements = computed(() => Store.getElements());
const modules = computed(() => Store.getModules());
const isLessonHistory = computed(() => Store.isLessonHistory());
const isExporting = computed(() => Store.isExporting());
const isLoading = computed(() => Store.isLoading());
</script>
